import paths from './config';

async function fetchJobDetailService(bulkUploadId, pageNumber, sortType = "DESC", sortId = "assetName") {
  return await fetch(paths.getJobDetail(bulkUploadId, pageNumber, sortType, sortId));
}

export default fetchJobDetailService;
